import { graphql } from "@/lib/gql/__generated__/gql";

export const PAYMENT_CREDIT_QUERY = graphql(/* GraphQL */ `
	query PaymentCreditQuery($hotelID: ID!) {
		paymentCredit(hotelID: $hotelID) {
			expired
			hotelID
			id
			last4
		}
		hotel(hotelID: $hotelID) {
			email
		}
		receiptSetting(hotelID: $hotelID) {
			id
			hotelID
			addressee
		}
	}
`);
